<template>
    <div>
        <Heading tag="h2" class="h2" margin="large" :title="sectionTitle" />
        <div class="scc-info-box" :class="`scc-info-box--${backgroundColor}`">
            <h4 class="scc-info-box__title">{{ title }}</h4>
            <p v-if="content1" class="scc-info-box__info">{{ content1 }}</p>
            <p v-if="content2" class="scc-info-box__info">{{ content2 }}</p>
            <p v-if="content3" class="scc-info-box__info">{{ content3 }}</p>
        </div>
    </div>
</template>

<script>
import './info-box.scss';
import Heading from './Heading';

export default {
    name: 'InfoBox',
    components: { Heading },
    __editor: {
        fields: {
            backgroundColor: {
                widget: 'select',
                values: ['primary', 'secondary', 'body', 'white'],
            },
        },
    },
    props: {
        backgroundColor: {
            type: String,
            required: false,
            default: 'white',
            validator: function(val) {
                return ['primary', 'secondary', 'body', 'white'].includes(val);
            },
        },
        sectionTitle: {
            type: String,
        },
        title: {
            type: String,
            default: 'Title',
        },
        content1: {
            type: String,
        },
        content2: {
            type: String,
        },
        content3: {
            type: String,
        },
    },
};
</script>
